var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var Actions = require('../../../modules/password/actions/password-reset');
var passwordResetClickActions = require( '../../../modules/meta/actions/passwordReset-click');
var PasswordReset = require('../components/password-reset.jsx');

  var mapStateToProps = function(state){
    return {
      password: state.password
    };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, Actions, passwordResetClickActions), dispatch);
  }

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PasswordReset);



// WEBPACK FOOTER //
// ./src/common/routes/password-reset/containers/password-reset.jsx